module.exports = __webpack_public_path__ + "img/tendler_benjamin.234d2c42.jpg";